import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24Share1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M8 7.63a.7.7 0 0 1 .095 1.394L8 9.03H7a1.3 1.3 0 0 0-1.293 1.167l-.007.133v9a1.3 1.3 0 0 0 1.167 1.293L7 20.63h9.78a1.3 1.3 0 0 0 1.293-1.167l.007-.133v-9a1.3 1.3 0 0 0-1.167-1.293l-.133-.007h-.81a.7.7 0 0 1-.095-1.394l.095-.006h.81a2.7 2.7 0 0 1 2.695 2.53l.005.17v9a2.7 2.7 0 0 1-2.53 2.695l-.17.005H7a2.7 2.7 0 0 1-2.695-2.53l-.005-.17v-9a2.7 2.7 0 0 1 2.53-2.695L7 7.63zm4.309-5.225.092.068 2.43 2.13A.701.701 0 0 1 14 5.724l-.092-.068-1.268-1.112v8.476a.7.7 0 0 1-1.394.095l-.006-.095V4.544L9.972 5.656a.7.7 0 0 1-1.003-.971l.08-.081 2.43-2.13a.7.7 0 0 1 .83-.07z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24Share1$1 = Svg24Share1;

export { Svg24Share1$1 as default };
